export default {
  "ORDER_WAIT_SHIP": "A aguardar envio",
  "Men fashion": "Moda masculina",
  "MyAccount_MyProfile_label_First": "Nome",
  "MyAccount_MyShippingDetails_Phone": "Número de telefone",
  "Page_not_found_message1": "Lamentamos, a página que procura não foi encontrada.",
  "Help": "Ajuda",
  "Sign in": "Entrar",
  "Register": "Registar",
  "Category_sorting_Item": "Selecionar método de ordenação",
  "cart_clear": "Limpar carrinho de compras",
  "Payment & Delivery": "Pagamento e envio",
  "Send my feedback": "Enviar o meu feedback",
  "MyAccount_MyProfile_Save": "Guardar alterações",
  "Continue_billing": "Continuar a pagar",
  "Categories": "Categorias",
  "Read and understand": "Li e compreendi",
  "Feel free to edit": "Edite as suas informações de conta sempre que quiser, para mantê-las atualizadas.",
  "Select payment method": "Selecione o método de pagamento",
  "Login_input_email": "O seu email",
  "Login_input_first": "Primeiro nome",
  "Account": "Conta",
  "Create_Time_Asc": "Data de criação ascendente",
  "concactus_label": "Sugestões ou questões",
  "Order_Grade": "Classificação da encomenda",
  "wishlist_empty_desc": "Parece que ainda não adicionou nenhum produto ao seu carrinho de compras. Comece a comprar agora!",
  "cartpreviewShipping_messageinfo": "Confirmaremos o envio e a data de chegada",
  "unsubscribe": "Pode cancelar a subscrição a qualquer momento",
  "prompt": "Prompt",
  "MyAccount_MyProfile_yinsi_message": "Na Brand name valorizamos muito a privacidade e estamos empenhados em proteger os dados pessoais dos utilizadores. Para obter mais informações sobre como cuidamos e utilizamos os seus dados pessoais, consulte a nossa",
  "About us": "Sobre nós",
  "or": "Ou",
  "MyAccount_Order_History_All": "Todas as encomendas",
  "What_We_Improve": "Como podemos melhorar?",
  "MyAccount_ShippingDetails_title": "Detalhes de envio",
  "MyAccount_Order_History_Tabs2": "Por pagar",
  "Go_back_shopping": "Voltar às compras",
  "Product": "Produto",
  "Order summary": "Resumo da encomenda",
  "payment_order_total": "Total da encomenda",
  "Departments": "Avisos legais",
  "Download": "Descarregar",
  "Your_Purchase_Order": "A sua encomenda",
  "Your_Account": "A sua conta",
  "order_after_sales_list_null": "Atualmente não tem nenhuma encomenda após-venda",
  "All_After_sales_orders": "Todas as encomendas após-venda",
  "Filters": "Filtros",
  "search_results_not": "Não foi possível encontrar resultados para a sua pesquisa.",
  "ORDER_WAIT_RECEIPT": "A aguardar receção",
  "ORDER_CLOSED": "Fechado",
  "Order_View_details": "Ver detalhes",
  "Subscribe_to_message": "Saiba antecipadamente sobre vendas e eventos futuros. Obtenha brindes e ofertas especiais!",
  "TaxFee": "Imposto e custo de envio",
  "Apply": "Aplicar",
  "Total_price": "Preço total",
  "Description": "Descrição",
  "Payment method": "Método de pagamento",
  "Back": "Voltar",
  "Empty": "Parece que ainda não adicionou nenhum produto ao seu carrinho de compras. Comece a comprar e preencha-o.",
  "After_sales": "Após-venda",
  "Instruction3": "Sim, sabemos.",
  "MyAccount_MyShippingDetails_Last": "Apelido",
  "MyAccount_MyShippingDetails_City": "Cidade",
  "payment_order_discount": "Desconto da encomenda",
  "MyAccount_Order": "Detalhes da encomenda",
  "ID_Name_Error": "Por favor, insira o nome do seu documento de identidade",
  "Kidswear": "Moda infantil",
  "Share your look": "Partilhe o seu visual",
  "Pay_Order": "Pagar encomenda",
  "Reset_Password": "Redefinir palavra-passe",
  "MyAccount_MyProfile_label2_pass1": "Palavra-passe atual",
  "Create_Time_Desc": "Data de criação descendente",
  "Items": "Itens",
  "Login_Register": "Registe-se agora",
  "Back to homepage": "Voltar à página inicial",
  "switch_CNY": "Alternar para CNY",
  "Successful placed order": "A sua encomenda foi colocada com sucesso. Pode verificar o estado da sua encomenda utilizando a nossa funcionalidade de rastreamento de envios. Receberá um email de confirmação da encomenda com informações detalhadas e um link de rastreamento.",
  "MyAccount_MyProfile_yinsi_link": "Política de privacidade",
  "Order_Date": "Data da encomenda",
  "Allow order notifications": "Permitir notificações de encomenda",
  "MyAccount_MyProfile_Tab1": "Perfil",
  "MyAccount_ShippingDetails_changeTitle": "Alterar endereço",
  "ID_Number": "Número do documento de identidade",
  "Order_after_sales_message": "Detalhes da encomenda e encomendas após-venda",
  "MyAccount_MyProfile_title2": "Se pretender alterar a palavra-passe de acesso à sua conta, insira as seguintes informações:",
  "Customer service": "Apoio ao cliente",
  "MyAccount_MyProfile_Update": "Atualizar palavra-passe",
  "choose_language": "Selecionar idioma",
  "ORDER_REFUNDING": "A aguardar reembolso",
  "MyAccount_MyProfile_title1": "Edite abaixo quaisquer informações detalhadas sempre que quiser, para manter a sua conta atualizada.",
  "ORDER_WAIT_RATE": "A aguardar avaliação",
  "after_sales_refund_order": "Reembolso da encomenda",
  "Who we are": "Quem somos",
  "Women fashion": "Moda feminina",
  "Personal details": "Detalhes pessoais",
  "Password": "Senha",
  "wishlist_empty_title": "O seu carrinho está vazio",
  "Repeat_Password": "Repita a senha",
  "cart_price": "Subtotal",
  "Sort_by": "Ordenar por",
  "Customer Reviews": "Avaliações de clientes",
  "Continue to shipping": "Continuar para o envio",
  "payment_make_order": "Fazer pedido",
  "save_order_review": "Enviar avaliação",
  "Save_Password": "Salvar senha",
  "cart_empty_title": "O seu carrinho está vazio",
  "TopBar_help": "Ajuda e Perguntas frequentes",
  "colseCookie": "Entendi",
  "Password_Changed": "Senha alterada com sucesso. Você pode agora voltar para a página principal e entrar.",
  "Forgot Password Modal Email": "O email que você usa para fazer o login:",
  "MyAccount_Personal": "Detalhes pessoais",
  "cartPreviewShipping": "Envio conveniente",
  "ORDER_AFTER_SALE": "Após venda",
  "Page_not_found": "Página não encontrada",
  "Find out more": "Saiba mais",
  "Log into your account": "Fazer login em sua conta",
  "Details_and_status_orders": "Verifique os detalhes e o status de seus pedidos em nossa loja online. Você também pode cancelar pedidos ou solicitar devoluções.",
  "Order_to_be_paid_message": "A pagar",
  "Guarantee": "Garantia",
  "Sections that interest you": "Seções que lhe interessam",
  "payment_post_tax": "Imposto sobre envio",
  "ORDER_PAID": "Pago",
  "concactus_label5": "Tratamento",
  "Item": "Artigo",
  "Go_back": "Voltar",
  "more": "Mais",
  "MyAccount": "Minha conta",
  "payment_agree_1": "Eu concordo com",
  "total_items": "Total de itens",
  "shopping_go": "Gerenciar endereços de entrega",
  "ID_Type": "Tipo de identificação",
  "after_sales_status": "Estado da após-venda",
  "After_sales_apply": "Aplicar após-venda",
  "Login": "Fazer login",
  "Quantity": "Quantidade",
  "payment_post_fee": "Taxa de envio",
  "MyAccount_Log_out": "Sair",
  "Subtotal": "Subtotal",
  "forgotPasswordConfirmation": "Obrigado! Se um endereço de email registrado com {0} for encontrado, você encontrará uma mensagem com um link para redefinir sua senha em sua caixa de entrada.",
  "MyAccount_Order_History_Tabs1": "Meus pedidos",
  "concactus_img": "Carregar imagem",
  "Done": "Concluído",
  "Info after order": "Você pode usar o email e a senha definidos anteriormente para fazer login em sua conta. Em sua conta, você pode editar seu perfil, ver seu histórico de transações, editar suas assinaturas de newsletters, etc.",
  "MyAccoubnt_Set_newsletter": "Configure sua newsletter. Você receberá novos produtos e tendências de seções que escolher semanalmente. ",
  "Shipping_method": "Método de envio",
  "after_sales_refund": "Reembolso após-venda",
  "After_sales_save": "Salvar informações após-venda",
  "go_order_history": "Ver histórico de pedidos",
  "contactus_message_placeholder": "Por favor, escreva seus comentários ou dúvidas aqui...",
  "Login_Forgot_Password": "Se você não conseguir lembrar sua senha, pode redefini-la.",
  "show_more": "Mostrar mais",
  "MyAccount_MyProfile_label_email": "Seu email",
  "MyAccount_MyProfile_label2_pass3": "Repita a senha",
  "Products": "Produtos",
  "Review": "Revisão",
  "MyAccount_MyProfile_title3": "Seu email atual é",
  "Category_found_Products": "Produtos encontrados",
  "Match": "Combinar",
  "Read_all_reviews": "Ler todas as avaliações",
  "Commercial information": "Concordo em receber informações comerciais personalizadas da marca por email.",
  "Change password your account": "Se você quiser alterar a senha de sua conta de acesso, insira as informações abaixo",
  "ID_Name": "Nome do titular do ID",
  "All": "Todos",
  "Instruction2": "Precisa apenas de instruções de manutenção?",
  "MyAccount_ShippingDetails_Add": "Adicionar novo endereço de entrega",
  "MyAccount_MyShippingDetails_Zip": "Código postal",
  "go_pay_order": "Pagar pedido",
  "Thank_You_Inbox": "Se a mensagem não chegar na sua caixa de entrada, tente usar outro endereço de e-mail que você possa ter usado para se registrar.",
  "Subscribe": "Inscrever-se",
  "confirm_subscription": "Confirme a inscrição",
  "Login_input_Remember": "Lembrar minha senha",
  "Add to compare": "Adicionar à comparação",
  "Brand": "Marca",
  "Start_shopping": "Começar a comprar",
  "Select shipping method": "Selecione um método de envio",
  "address CN": "O endereço está na China, a moeda atual deve ser CNY",
  "MyAccount_MyShippingDetails_State": "Estado",
  "Page_not_found_message2": "Por favor, volte ou tente novamente",
  "Go_to_checkout": "Ir para o checkout",
  "See all results": "Ver todos os resultados",
  "search_results_inputnull": "Você ainda não pesquisou por nenhum produto.",
  "subscribeToNewsletterModalContent": "Ao se inscrever na newsletter, você receberá ofertas exclusivas e informações da VSF por e-mail. Nós nunca venderemos ou distribuiremos seu email para terceiros. Veja nossa {0}.",
  "Download all": "Baixar tudo",
  "Login_input_last": "Sobrenome",
  "Amount": "Montante",
  "ORDER_WAIT_PAYMENT": "Aguardando pagamento",
  "Order_After_sales": "Encomendas pós-venda",
  "concattus_button": "Submeter",
  "Shipping_valid_required": "Este campo é obrigatório",
  "Price": "Preço",
  "ID_Type_Error": "Por favor, selecione o tipo de seu documento de identidade",
  "Order_Status": "Estado da encomenda",
  "Payment methods": "Métodos de pagamento",
  "MyAccount_MyProfile_Tab2": "Alterar palavra-passe",
  "Show on page": "Mostrar na página",
  "Edit": "Editar",
  "Change": "Alterar",
  "MyAccount_ShippingDetails_Update": "Atualizar endereço",
  "View": "Visualizar",
  "Privacy": "Privacidade",
  "Enter_promo_code": "Introduza o código promocional",
  "Discount": "Desconto",
  "Delete": "Eliminar",
  "Wishlist": "Lista de desejos",
  "MyAccount_Order_History_Tabs3": "Devolução",
  "Go_To_Order_review": "Ir para avaliação",
  "Update personal data": "Atualizar dados pessoais",
  "payment_agree_2": "Termos e condições",
  "or fill the details below": "ou preencha os detalhes abaixo",
  "Contact details updated": "Mantenha o seu endereço e os detalhes de contato atualizados.",
  "Login_Create": "Criar conta",
  "Payment": "Pagamento",
  "Billing": "Faturação",
  "payment_insurance_tax": "Seguro e imposto",
  "Size guide": "Guia de tamanho",
  "Login_forgotten_password": "Esqueceu a palavra-passe?",
  "Login_no_account": "Ainda não tem conta?",
  "Privacy_Policy": "Política de privacidade",
  "BootomCookieTitle": "Permissão de cookies",
  "Use your personal data": "Na Brand name, a proteção de dados pessoais dos nossos utilizadores é muito importante para nós. Para obter mais informações sobre como tratamos e utilizamos os seus dados pessoais, consulte a nossa",
  "Review my order": "Ver minha encomenda",
  "BootomCookieLink": "Saber mais",
  "hide": "Ocultar",
  "MyAccount_ShippingDetails_message_title": "A gestão dos seus endereços de envio é fácil e rápida. Adicione, edite e elimine qualquer endereço de envio e torne o processo de compra ainda mais rápido!",
  "Purchase terms": "Termos de compra",
  "Billing_address": "Endereço de faturação",
  "Manage shipping addresses": "Gerencie todos os endereços de envio desejados (local de trabalho, endereço pessoal, etc.) para que não precise inserir manualmente os detalhes em cada encomenda.",
  "login_logbtn": "Entrar na conta",
  "choose_currency": "Escolher moeda",
  "ORDER_REFUNDED": "Pedido reembolsado",
  "After_sales_form": "Formulário pós-venda",
  "add_To_Wishlist": "Adicionar à lista de desejos",
  "search_results_inputnull2": "Comece agora e deixe-nos orientá-lo.",
  "Total": "Total",
  "Subscribe_to_newsletter": "Subscrever a newsletter",
  "Shipping_valid_Phone": "Por favor, introduza um número de telefone válido",
  "concactus_label3": "Título",
  "Manage billing addresses": "Gerencie todos os endereços de faturação desejados (local de trabalho, endereço pessoal, etc.) para que não precise inserir manualmente os detalhes em cada encomenda.",
  "Search_results_title": "Resultados da pesquisa",
  "payment_order_payment": "Pagamento da encomenda",
  "after_sales_Id": "ID pós-venda",
  "cart_title": "O meu carrinho",
  "Order_Detail": "Detalhes da encomenda",
  "concactus_label2": "Link da loja",
  "Shipping_valid_length_min": "Este campo deve ter pelo menos {min} caracteres",
  "Product suggestions": "Sugestões de produtos",
  "Return_home": "Voltar para a página inicial",
  "Quality in the details": "Os detalhes importam",
  "Continue_to_payment": "Continuar para pagamento",
  "Feedback": "O seu feedback é importante para nós. Por favor, informe-nos sobre o que podemos melhorar.",
  "Go back to shop": "Voltar para a loja",
  "Back_to_home": "Voltar para a página inicial",
  "Review_Content": "Conteúdo da avaliação",
  "add_To_Cart": "Adicionar ao carrinho",
  "Read_reviews": "Ler comentários",
  "Instruction1": "Instruções de cuidado",
  "Email_address": "Endereço de e-mail",
  "Category_Item_List": "Alternar para vista de lista",
  "Same as shipping address": "Igual ao endereço de entrega",
  "Category_Item_Grid": "Alternar para vista de grelha",
  "ID_Number_Error": "Por favor, introduza o seu número de identificação pessoal",
  "concactus_label4": "E-mail de contacto",
  "Additional_info": "Informação adicional",
  "add_shipping": "Adicionar novo endereço de entrega",
  "Product_description": "A Karissa V-Neck Tee apresenta um design semi-justo que favorece vários tipos de corpo. Ele adere às curvas, cobrindo as áreas problemáticas comuns, permitindo que se sinta confiante na academia. Também estão disponíveis vestidos de coquetel e de festa fe",
  "Login_create_account": "Criar nova conta",
  "after_sales_Reason": "Motivo do pós-venda",
  "MyAccount_MyProfile_label_Last": "Último nome",
  "MyAccount_MyProfile_label2_pass2": "Nova palavra-passe",
  "Save": "Salvar",
  "CartSliderTextBtn": "Adicionar aos itens para mais tarde",
  "Color": "Cor",
  "Shipping_Tax": "Impostos de envio",
  "Subscribe_to_success": "Subscrição com sucesso",
  "Enjoy your free account": "Desfrute das vantagens da sua conta gratuita!",
  "cart_empty_desc": "Parece que ainda não adicionou nenhum produto ao carrinho de compras. Comece a comprar para enchê-lo!",
  "MyAccount_ShippingDetails_message_title2": "Mantenha o seu endereço e os seus dados atualizados!",
  "An_error_occured": "Ocorreu um erro",
  "Country": "País",
  "MyAccount_MyShippingDetails_First": "Primeiro nome",
  "payment_insurance_fee": "Taxa de seguro",
  "Home": "Início",
  "Contact_us": "Contacte-nos",
  "Cookies Policy": "Política de cookies",
  "Clear all": "Limpar tudo",
  "Basket": "Carrinho de compras",
  "MyAccount_MyProfile_reqeatPassErrMsg": "Nova senha não coincide",
  "Your current email address is": "Seu endereço de e-mail atual é",
  "You currently have no orders": "Atualmente, você não possui pedidos",
  "Login_input_password": "Senha",
  "Promo_code": "Código promocional",
  "order_count": "Quantidade de pedidos",
  "email_geshi_error": "Por favor, insira um endereço de email válido",
  "your_email": "Seu endereço de email",
  "email": "Email",
  "you_have_subscribed": "Você se inscreveu",
  "cancel_Subscribe": "Cancelar inscrição",
  "save_and_pay": "Guardar e pagar",
  "hasInsurance": "Tem seguro?",
  "pleasePayType": "Por favor, escolha o método de pagamento",
  "zhuanfa_toBePay": "Transferir para o amigo pagar por ti",
  "linkCopied": "Link copiado, partilha com os teus amigos!",
  "Links": "Ligações",
  "article_category": "Categoria de artigos",
  "wechat_code_login_message": "Por favor, use o código QR do WeChat para fazer login",
  "wechat_code_login": "Login com código QR do WeChat",
  "Api_Update_success": "Atualizado com sucesso",
  "Please_Use_WeChat_login": "Por favor, faça login com o WeChat",
  "mobile_geshi_error": "Por favor, insira um número de telefone válido",
  "Login_input_email_required": "Por favor, insira um endereço de email",
  "article_null": "Nenhum artigo disponível",
  "Login_with_microsoft": "Login com Microsoft",
  "article_null_des": "Você pode visualizar artigos em outras categorias",
  "register_email": "Registro por email",
  "Login_tab_email": "Login por email",
  "code.time": "Tentar novamente em {time} segundos",
  "Login_with_wechat": "Login com WeChat",
  "cat_items_null_des": "Você pode visualizar produtos em outras categorias",
  "Login_with_facebook": "Login com Facebook",
  "Login_input_code": "Código de verificação",
  "Login_input_mobile_required": "Por favor, insira um número de telefone",
  "Login_input_mobile": "Seu número de telefone",
  "cat_items_null": "Nenhum produto disponível nesta categoria",
  "Login_with_twitter": "Login com Twitter",
  "mobile_code": "Código de verificação",
  "register_mobile": "Registro por celular",
  "Login_tab_mobile": "Login por celular",
  "Login_with_google": "Login com Google",
  "OrderSku": "Especificação do Produto",
  "Order_logisticsNo": "Número de Rastreamento",
  "order_shopping_firstname": "Nome",
  "Order_logisticsName": "Empresa de Logística",
  "ItemPrice": "Valor do produto",
  "inPayOrderAll": "Lista de pagamento pendente",
  "payPrice": "Valor pago",
  "shipping_add_success": "Endereço de envio criado com sucesso",
  "match_goods": "Produtos em destaque",
  "pay_code_refresh": "Atualizar código de pagamento",
  "pay_code_shixiao": "O código de pagamento expirou",
  "concactus_title": "Contate-Nos",
  "Search_items": "Busca",
  "WebAutoLang": "Seu navegador recomendou que seu idioma atual é: {lang}, você gostaria de mudar para este idioma?",
  "Services_Name": "Nome do serviço",
  "Services_Price": "Custo do serviço",
  "SwichLang": "Alterar idioma",
  "Services_Description": "Descrição do serviço",
  "goodinfo_null": "Sem produtos disponíveis",
  "goodinfo_null_des": "Você pode navegar por outros produtos de categoria",
  "notYetUseCode": "Código de cupom não utilizado",
  "guest_Login": "Login de convidado",
  "billing_and_shipping": "Faturamento e endereço de entrega são os mesmos",
  "select_coupon": "Selecionar cupom",
  "select_gift": "Selecionar presente",
  "currentUseCode": "Código de cupom utilizado",
  "shipping_refresh": "Atualizar lista",
  "Shipping_details": "Endereço de envio",
  "MyAccount_Newsletter": "Inscrição",
  "MyAccount_Profile": "Perfil",
  "MyAccount_Wishlist": "Lista de desejos",
  "See_all": "Todos",
  "MyAccount_History": "Histórico de pedidos",
  "bind_microsoft": "Ligar à Microsoft",
  "bind_twitter": "Ligar ao Twitter",
  "bind_facebook": "Ligar ao Facebook",
  "bind_wechat_code": "Código QR WeChat",
  "bind_wechat": "Ligar ao WeChat",
  "bind_google": "Ligar ao Google",
  "Wishlist_Empty": "Sem lista de desejos",
  "discount_post_fee": "Desconto no frete",
  "ORDER_PART_PAID": "Pagamento Parcial",
  "claimCouponeSuccess": "Obter sucesso {name}",
  "discount_kou": "{discount} de desconto",
  "claimCoupone": "Reivindicar",
  "cartPreviewSafety_messageinfo": "Entrega segura e rápida para o seu endereço",
  "Order_No": "Número do pedido",
  "cartPreviewSafety": "Entrega Segura",
  "Shipping": "Entrega",
  "MyAccount_MyShippingDetails_Street": "Rua",
  "MyAccount_MyShippingDetails_HouseNumber": "Número da Casa",
  "Shipping_title": "Endereço de entrega",
  "Offline_payment": "Pagamento offline",
  "shopName": "Nome da loja",
  "Social": "Social",
  "SERVICE": "Serviço",
  "onlineContact": "Contato Online",
  "confirm": "Confirmar",
  "closeOrder": "Cancelar pedido",
  "closeOrderContext": "Tem certeza de que deseja cancelar o pedido?",
  "Message_Read": "Lido",
  "close.order.success": "Pedido cancelado com sucesso",
  "shippingAddress": "Endereço completo",
  "Message": "Mensagem",
  "Message_Empty_Title": "Suas mensagens estão vazias",
  "MyAccount_Message": "Mensagem",
  "Message_Empty": "Sem mensagens no momento",
  "payment_order_note": "Observação do pedido",
  "go_to_see_prepid": "Clique aqui para ver os pedidos não pagos",
  "operate": "Operação",
  "removeCartItemContext": "Tem certeza que quer remover {title}?",
  "shippingItemQty": "Quantidade de envio",
  "removeCartItem": "Remover item",
  "shippingInfo": "Informação de envio",
  "Distributor_success": "Já é um distribuidor de sucesso",
  "Distributor_apply": "Solicitar ser um distribuidor",
  "Distributor_Details": "Distribuidor",
  "DistributorSataus": "Status",
  "Distributor_Details_Empty": "Sem distribuidor",
  "distributor.status.4": "Cancelado",
  "distributor.status.1": "Não auditado",
  "Distributor_copy_url": "Copiar link de distribuição",
  "Order_Time": "Horário do pedido",
  "Order_User": "Pedidor",
  "Distributor_copy_success": "Cópia bem sucedida",
  "distributor.status.3": "Já liquidado",
  "MyAccount_Distributor": "Distribuidor",
  "MyAccoubnt_Set_Distributor": "Solicitar ser um distribuidor",
  "distributor.status.2": "Em espera para liquidar",
  "DistributorAmount": "Comissão",
  "Distributor_shenheshibai": "Distribuidor não aprovado",
  "Distributor_shenhezhong": "Distribuidor em análise",
  "Distributor_Order_Empty": "Nenhum pedido de distribuidor",
  "NE": "Níger",
  "DJ": "Djibuti",
  "KP": "Coreia do Norte",
  "US": "Estados Unidos",
  "LC": "Santa Lúcia",
  "NL": "Países Baixos",
  "CD": "República Democrática do Congo",
  "IS": "Islândia",
  "MA": "Marrocos",
  "GH": "Gana",
  "KR": "Coreia do Sul",
  "MK": "Macedônia",
  "HT": "Haiti",
  "PF": "Polinésia Francesa",
  "GA": "Gabão",
  "TD": "Chade",
  "LB": "Líbano",
  "CG": "Congo",
  "KG": "Quirguistão",
  "TA": "Tristão da Cunha",
  "KW": "Kuwait",
  "TL": "Timor-Leste",
  "IN": "Índia",
  "NO": "Noruega",
  "NG": "Nigéria",
  "AQ": "Antártida",
  "LY": "Líbia",
  "NI": "Nicarágua",
  "TT": "Trinidad e Tobago",
  "HM": "Ilhas Heard e McDonald",
  "PY": "Paraguai",
  "BA": "Bósnia e Herzegovina",
  "JP": "Japão",
  "MD": "Moldávia",
  "MT": "Malta",
  "RE": "Reunião",
  "UG": "Uganda",
  "SB": "Ilhas Salomão",
  "SL": "Serra Leoa",
  "CV": "Cabo Verde",
  "SD": "Sudão",
  "FO": "Ilhas Faroe",
  "ZA": "África do Sul",
  "TR": "Turquia",
  "FK": "Ilhas Falkland (Malvinas)",
  "PA": "Panamá",
  "GF": "Guiana Francesa",
  "TJ": "Tajiquistão",
  "NC": "Nova Caledônia",
  "PM": "Saint-Pierre e Miquelon",
  "NU": "Niue",
  "AO": "Angola",
  "VN": "Vietnã",
  "GN": "Guiné",
  "MW": "Malawi",
  "BY": "Bielorrússia",
  "IM": "Ilha de Man",
  "BI": "Burundi",
  "BS": "Bahamas",
  "CK": "Ilhas Cook",
  "MH": "Ilhas Marshall",
  "CR": "Costa Rica",
  "HK": "Hong Kong, SAR China",
  "AD": "Andorra",
  "BN": "Brunei",
  "SN": "Senegal",
  "AE": "Emirados Árabes Unidos",
  "GI": "Gibraltar",
  "CA": "Canadá",
  "AX": "Ilhas Aland",
  "UY": "Uruguai",
  "WF": "Wallis e Futuna",
  "GM": "Gâmbia",
  "SO": "Somália",
  "RU": "Rússia",
  "PL": "Polônia",
  "FM": "Micronésia",
  "ET": "Etiópia",
  "EE": "Estônia",
  "SK": "Eslováquia",
  "AS": "Samoa Americana",
  "ZM": "Zâmbia",
  "AL": "Albânia",
  "AT": "Áustria",
  "VA": "Vaticano",
  "TW": "Taiwan",
  "BD": "Bangladesh",
  "AR": "Argentina",
  "EH": "Saara Ocidental",
  "MO": "Macau",
  "MV": "Maldivas",
  "GU": "Guam",
  "AW": "Aruba",
  "AI": "Anguilla",
  "CL": "Chile",
  "IL": "Israel",
  "GD": "Granada",
  "WS": "Samoa",
  "SE": "Suécia",
  "GP": "Guadalupe",
  "YE": "Iêmen",
  "GT": "Guatemala",
  "BG": "Bulgária",
  "SJ": "Svalbard e Jan Mayen",
  "CO": "Colômbia",
  "LS": "Lesoto",
  "LV": "Letônia",
  "UM": "Ilhas Menores Distantes dos Estados Unidos",
  "MX": "México",
  "DO": "República Dominicana",
  "PE": "Peru",
  "HN": "Honduras",
  "TC": "Ilhas Turks e Caicos",
  "VI": "Ilhas Virgens Americanas",
  "FJ": "Fiji",
  "MP": "Ilhas Marianas do Norte",
  "AC": "Ilha de Ascensão",
  "NA": "Namíbia",
  "SZ": "Suazilândia",
  "RW": "Ruanda",
  "BH": "Bahrein",
  "KN": "São Cristóvão e Neves",
  "TN": "Tunísia",
  "AF": "Afeganistão",
  "VG": "Ilhas Virgens Britânicas",
  "KE": "Quênia",
  "PK": "Paquistão",
  "GL": "Gronelândia",
  "SY": "Síria",
  "CU": "Cuba",
  "RS": "Sérvia",
  "BF": "Burkina Faso",
  "BM": "Bermudas",
  "BZ": "Belize",
  "SV": "El Salvador",
  "CN": "China",
  "MF": "São Martinho",
  "NF": "Ilha Norfolk",
  "MZ": "Moçambique",
  "LU": "Luxemburgo",
  "TO": "Tonga",
  "GR": "Grécia",
  "SI": "Eslovênia",
  "PW": "Palau",
  "TZ": "Tanzânia",
  "IR": "Irã",
  "GG": "Guernsey",
  "SM": "San Marino",
  "TF": "Territórios Franceses do Sul",
  "PS": "Palestina",
  "SC": "Seychelles",
  "BT": "Butão",
  "JM": "Jamaica",
  "BR": "Brasil",
  "CH": "Suíça",
  "SH": "Santa Helena",
  "HU": "Hungria",
  "TM": "Turcomenistão",
  "LT": "Lituânia",
  "MC": "Mônaco",
  "LI": "Liechtenstein",
  "LR": "Libéria",
  "GE": "Geórgia",
  "SA": "Arábia Saudita",
  "GB": "Reino Unido",
  "VE": "Venezuela",
  "MU": "Maurício",
  "HR": "Croácia",
  "SR": "Suriname",
  "CM": "Camarões",
  "IQ": "Iraque",
  "BO": "Bolívia",
  "MN": "Mongólia",
  "DZ": "Argélia",
  "TK": "Tokelau",
  "MG": "Madagáscar",
  "YT": "Mayotte",
  "CC": "Ilhas Cocos (Keeling)",
  "LA": "Laos",
  "PT": "Portugal",
  "QA": "Catar",
  "AN": "Antilhas Holandesas",
  "PN": "Ilha Pitcairn",
  "ES": "Espanha",
  "VC": "São Vicente e Granadinas",
  "AU": "Austrália",
  "CX": "Ilha do Natal",
  "KM": "Comores",
  "MR": "Mauritânia",
  "FR": "França",
  "SG": "Singapura",
  "BV": "Ilha Bouvet",
  "PH": "Filipinas",
  "CY": "Chipre",
  "TV": "Tuvalu",
  "CF": "República Centro-Africana",
  "EC": "Equador",
  "GW": "Guiné-Bissau",
  "IE": "Irlanda",
  "LK": "Sri Lanka",
  "ER": "Eritreia",
  "GQ": "Guiné Equatorial",
  "NP": "Nepal",
  "BE": "Bélgica",
  "GY": "Guiana",
  "DK": "Dinamarca",
  "MQ": "Martinica",
  "UZ": "Uzbequistão",
  "CI": "Costa do Marfim",
  "ID": "Indonésia",
  "BJ": "Benin",
  "ST": "São Tomé e Príncipe",
  "KH": "Camboja",
  "KZ": "Cazaquistão",
  "MS": "Montserrat",
  "TH": "Tailândia",
  "FI": "Finlândia",
  "ML": "Mali",
  "AM": "Armênia",
  "IT": "Itália",
  "NR": "Nauru",
  "PG": "Papua-Nova Guiné",
  "ZW": "Zimbábue",
  "JO": "Jordânia",
  "OM": "Omã",
  "ME": "Montenegro",
  "JE": "Jersey",
  "NZ": "Nova Zelândia",
  "VU": "Vanuatu",
  "DE": "Alemanha",
  "CZ": "República Tcheca",
  "DM": "Dominica",
  "KY": "Ilhas Cayman",
  "BW": "Botsuana",
  "RO": "Romênia",
  "PR": "Porto Rico",
  "AZ": "Azerbaijão",
  "IO": "Território Britânico do Oceano Índico",
  "UA": "Ucrânia",
  "TG": "Togo",
  "MY": "Malásia",
  "AG": "Antígua e Barbuda",
  "EG": "Egito",
  "GS": "Ilhas Geórgia do Sul e Sandwich do Sul",
  "MM": "Mianmar",
  "BB": "Barbados",
  "KI": "Kiribati",
  "All_Country": "Todos",
  "post_state_country": "Taxa de envio: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "Entrega para",
  "ShippingFee": "Taxa de entrega",
  "reviewOutOf": "{rating} estrelas, de um total de 5 estrelas",
  "product.pifa.label": "Compre de {startnum} a {endnum} unidades",
  "product.pifa.type.1": "Desconto",
  "Write_a_review": "Escreva uma avaliação",
  "BasedOnTotalReviews": "Com base em {total} avaliações",
  "product.wholesale": "Preço de atacado",
  "reviewMostRecent": "Avaliações mais recentes",
  "product.pifa.type.2": "Preço unitário",
  "product.num.danwei": "unidade",
  "good.shoppingDateLabel": "Data de envio",
  "good.shippingPeriod": "Envio em dias",
  "emailError": "Formato de email incorreto",
  "addressNote": "Nota de endereço",
  "Concactus": "Contato",
  "addressMessage": "Certifique-se de que seu endereço está correto. Não podemos mudar o endereço após o checkout.",
  "showOrderSummary": "Resumo do pedido",
  "payment_method": "Forma de pagamento",
  "emailNotNullError": "O e-mail não pode estar vazio",
  "orderCreateLoading": "Criando o pedido...",
  "emailNote": "Contato",
  "emailMessage": "Certifique-se de que seu endereço de e-mail está correto. Enviaremos um e-mail de confirmação do pedido para você.",
  "payment_method_message": "Todas as transações são seguras e criptografadas.",
  "go_buy_goods": "Continuar comprando",
  "tap_cancel_order": "Clique aqui para cancelar o pedido",
  "order_review": "Avaliação do pedido",
  "Add_new_address": "Adicionar novo endereço",
  "promo_code_type_3": "Cupom de presente",
  "IdCardNotNull": "Por favor preencha suas informações pessoais",
  "UploadVideo": "Carregar vídeo",
  "video": "Vídeo",
  "UploadImage": "Carregar imagem",
  "uploadImageing": "Carregando...",
  "BillingInfoNotNull": "Informações de faturamento incompletas",
  "promo_code_type_2": "Cupom de desconto",
  "UploadError": "Erro no carregamento",
  "promo_code_type_4": "Cupom de desconto na entrega",
  "image": "Imagem",
  "paymentMethodNotNull": "Por favor, selecione um método de pagamento",
  "promo_code_type_1": "Cupom de desconto",
  "shippingInfoNotNull": "Informações de envio incompletas",
  "reviewDetail": "Detalhes da avaliação",
  "DeliveryCountry": "Área de entrega",
  "prompt_error": "Erro de Prompt",
  "save_review_success": "Avaliação salva com sucesso",
  "ORDER_COMPLETED": "Concluído",
  "crate_after_sales": "Criar pós-vendas",
  "Thank_You_Order": "Obrigado pelo seu pedido!",
  "Thank_You_Order_sub": "Em breve vamos processar seu pedido e você receberá um e-mail contendo informações sobre o processamento do pedido.",
  "BootomCookieContext": "Este site usa cookies para ajudar o site a funcionar normalmente e nos ajuda a entender como interagir com ele. Usamos esses cookies para fornecer uma experiência de usuário personalizada melhor para você. Se você continuar a usar este site, assumiremos q",
  "order_reivice_message": "Você tem certeza de que recebeu a mercadoria?",
  "order_reivice_btn": "Confirma receber",
  "order_reivice_label": "Recepção de Orderos",
  "order_reivice_success": "Confirmação de recebimento bem-sucedida",
  "collpase_show": "Veja mais",
  "collpase_hide": "Dobra",
  "CouponCode": "Código de cupom",
  "wechatPayScannerCode": "Por favor, faça o pagamento digitalizando o código QR do WeChat",
  "processing": "Processando após venda",
  "finished": "Após venda concluída",
  "login.showPrice": "Faça login para ver o preço",
  "After_Sales_Unknown": "Status do pós-venda desconhecido",
  "order_payment_list_null": "Nenhum pedido pendente de pagamento",
  "Cancel": "Cancelar",
  "thankyou_concat": "Se você tiver alguma dúvida, entre em contato conosco"
}